<template>
  <div class="input-password">
    <input
      v-model="tempValue"
      type="password"
      :placeholder="placeholder"
      :maxlength="maxlength"
    />
    <div class="error-message">{{ errorMsg }}</div>
  </div>
</template>

<script>
export default {
  name: 'input-password',
  props: {
    password: {
      default: '',
      type: String
    },
    maxlength: {
      default: 20,
      type: Number
    },
    placeholder: {
      default: 'PASSWORD',
      type: String
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      tempValue: '',
      msg: ''
    }
  },
  created() {
    this.tempValue = this.password
  },
  updated() {
    if (this.required) {
      if (this.tempValue.length > 8) {
        this.$emit('model', this.tempValue)
        this.msg = ''
      } else {
        console.log('It`s works')
        this.msg = '비밀번호를 8자 이상 입력해주세요.'
      }
    } else {
      this.$emit('model', this.tempValue)
    }
  },
  computed: {
    errorMsg() {
      return ''
      // return this.msg
    }
  }
}
</script>

<style lang="scss" scoped>
.input-password {
  input {
    width: 87%;
    height: 50px;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1px;
    color: #000000;
    padding: 0 16px 0 16px;
    margin: 10px 0 0 0;
    background-color: #ffffff;
    border: solid 1px #e7e7e7;
    outline: none;
  }

  .error-message {
    font-size: 10px;
    color: #464746;
    margin: 0 0 0 10px;
  }
}
</style>
